"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarTheme = void 0;
var primary = "#59801bff";
exports.calendarTheme = {
    colors: {
        divid: primary,
        coloredText: "#3E5716",
        accent: "#E3FFB7",
        accentDulled: "#acc484ff",
        secondary: "#666666",
        border: "#dcdcdc",
        borderHighContrast: "#222222",
        textHighlight: "#ff0000",
        sundayText: "#8B0000",
        background: "#ffffff",
        body: "#222222",
        inputLabel: "#555555",
        bodyInverted: "#ffffff",
        currentDayHighlight: "#e6e6e6",
        dropShadow: "#00000040",
        dropShadowHighContrast: "#00000077",
        filterGroups: {
            // These colors need to meet AA standard with white text on top
            default: primary,
            Munters: "#006f88",
            FläktGroup: "#877043ff",
            Systemair: "#004888",
            Nibe: "#880000",
            Panasonic: "#242526",
            Custom: primary,
            Product: primary,
            ProductDevelop: primary,
            ProductCustomer: primary,
            Desks: primary,
            Parking: primary,
        },
    },
};
//# sourceMappingURL=theme.js.map